
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.94 49.716c-1.05 0-2.19-.16-3.39-.488C26.49 46.52 13.043 33.05 10.394 23.024c-.98-3.683-.41-6.7 1.64-8.71l3.069-3.057a3.04 3.04 0 012.3-.876c.81.04 1.58.398 2.18.985l6.008 5.864c.66.657 1.03 1.504 1.05 2.38.02.886-.3 1.722-.92 2.34l-2.46 2.548c1.42 2.987 2.67 5.047 4.77 7.029 2.09 1.97 4.07 3.335 7.099 4.888l2.56-2.549c.62-.617 1.47-.916 2.4-.856.859.07 1.689.458 2.329 1.095l5.899 5.874c1.3 1.474 1.33 3.385.12 4.59l-3.07 3.056c-1.39 1.394-3.23 2.09-5.429 2.09zM17.222 12.372c-.2 0-.47.06-.71.289l-3.07 3.056c-1.54 1.513-1.91 3.793-1.12 6.8 2.46 9.308 15.418 22.28 24.746 24.79 3.03.816 5.35.448 6.89-1.086l3.069-3.056c.52-.518.28-1.304-.17-1.822l-5.85-5.824a1.723 1.723 0 00-1.069-.518c-.24-.02-.57.02-.83.279l-3.07 3.056a.995.995 0 01-1.15.19c-3.599-1.792-5.828-3.296-8.218-5.546-2.47-2.33-3.89-4.788-5.499-8.253a.985.985 0 01.19-1.105l2.95-3.057c.24-.239.36-.547.35-.886a1.472 1.472 0 00-.46-1.015l-6.01-5.864-.01-.01c-.25-.249-.57-.398-.88-.408-.04-.01-.06-.01-.08-.01z"}})])
          )
        }
      }
    